import { NeedHelpController } from "./need-help-btn.controller";

angular
    .module("thor.shared.need-help-btn.component", [])
    .component("needHelpBtn", {
        bindings: {},
        controller: NeedHelpController,
        template: require("./need-help-btn.html")
    });
